export default __webpack_public_path__ + "static/media/blob white.caf99a44.svg";